import React from 'react';
import PropTypes from 'prop-types';
import EventEmitter from '../../modules/event-emitter/EventEmitter';
import OverviewPrice from '../overviewPrice/OverviewPrice';
import InfoModal from '../../searchBox/infoModal/InfoModal';
import Listener from '../../../const/Listener';
import ExchangeService from '../../../services/exchange/ExchangeService';

const I18n = require('i18n-react').default;

const propTypes = {
  quotationJourney: PropTypes.object,
  alterFlight: PropTypes.bool.isRequired,
  renderOpen: PropTypes.bool
};

const defaultProps = {
  renderOpen: false
};

class OverviewPriceContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      messageInfo: null,
      showPrices: false
    };

    this.obtainPoints = this.obtainPoints.bind(this);
    this.getPoints = this.getPoints.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    if (this.props.quotationJourney) {
      this.setState({
        quotationJourney: this.props.quotationJourney,
        showPrices: true
      });
    }
  }

  componentDidMount() {
    this.setState({
      calculatePointslistener: EventEmitter.createListener(
        Listener.CALCULATE_POINTS_LISTENER,
        this.obtainPoints
      ),
      clearOverview: EventEmitter.createListener(
        Listener.CLEAR_OVERVIEW_LISTENER,
        this.clearOverview.bind(this)
      )
    });
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.calculatePointslistener);
    EventEmitter.removeListener(this.state.clearOverview);
  }

  clearOverview() {
    this.setState({
      showPrices: false
    });
  }

  obtainPoints([quotationJourney]) {
    this.setState({
      quotationJourney: quotationJourney
    });

    let promises = this.obtainPointsDeparture(quotationJourney);
    if (quotationJourney.returnFlight) {
      promises = promises.concat(this.obtainPointsReturn(quotationJourney));
    }

    var promisesFiltered = promises.filter(function(promise) {
      return promise !== undefined;
    });

    return Promise.all(promisesFiltered)
      .then(() => {
        this.setState({
          showPrices: true,
          quotationJourney: {
            ...this.state.quotationJourney,
            values: this.obtainValues()
          }
        });
        EventEmitter.emitEvent(Listener.UPDATE_QUOTATION_JOURNEY, this.state.quotationJourney);
      })
      .catch(error => {
        let mensagem = '';
        if (error.body && error.body.reason !== null) {
          mensagem = (
            <div>
              <p>{I18n.translate('home.msg.error')}</p>
              <p>Reason: </p>
              <p>{error.body.reason}</p>
            </div>
          );
        } else {
          mensagem = I18n.translate('home.msg.error');
        }
        this.showModal(mensagem);
      });
  }

  obtainPointsDeparture(quotationJourney) {
    let departureChildPointsPromise;
    let departureInfantPointsPromise;
    let departureFlightObject = quotationJourney.departureFlight;

    let items = {
      departureFlightAirport: quotationJourney.origin,
      arrivalFlightAirport: quotationJourney.finalDestination,
      departureFlightDate: departureFlightObject.flight.departureDate,
      departureFlightTime: departureFlightObject.flight.departureTime,
      operatingCarriers: departureFlightObject.flight.operatingCarriers,
      cabin: departureFlightObject.category.toUpperCase()
    };

    if (
      !quotationJourney.departureFlight.childValue &&
      quotationJourney.passengers.childNumber > 0
    ) {
      let childPrice = this.getPrice(
        departureFlightObject.flight.prices,
        departureFlightObject.category,
        'CHILD'
      );
      departureChildPointsPromise = this.getDeparturePointsPromise(
        quotationJourney,
        items,
        childPrice[0],
        departureFlightObject.flight.fareOriginType || childPrice[0].classType,
        false
      );
    }
    if (
      !quotationJourney.departureFlight.infantValue &&
      quotationJourney.passengers.infantNumber > 0
    ) {
      let infantPrice = this.getPrice(
        departureFlightObject.flight.prices,
        departureFlightObject.category,
        'INFANT'
      );
      departureInfantPointsPromise = this.getDeparturePointsPromise(
        quotationJourney,
        items,
        infantPrice[0],
        departureFlightObject.flight.fareOriginType || infantPrice[0].classType,
        true
      );
    }

    return [departureChildPointsPromise, departureInfantPointsPromise];
  }

  obtainPointsReturn(quotationJourney) {
    let returnChildPointsPromise;
    let returnInfantPointsPromise;
    let returnFlightObject = quotationJourney.returnFlight;

    let items = {
      departureFlightAirport: quotationJourney.finalDestination,
      arrivalFlightAirport: quotationJourney.origin,
      departureFlightDate: returnFlightObject.flight.departureDate,
      departureFlightTime: returnFlightObject.flight.departureTime,
      cabin: returnFlightObject.category.toUpperCase(),
      operatingCarriers: returnFlightObject.flight.operatingCarriers
    };

    if (!quotationJourney.returnFlight.childValue && quotationJourney.passengers.childNumber > 0) {
      let childPrice = this.getPrice(
        returnFlightObject.flight.prices,
        returnFlightObject.category,
        'CHILD'
      );
      returnChildPointsPromise = this.getReturnPointsPromise(
        quotationJourney,
        items,
        childPrice[0],
        returnFlightObject.flight.fareOriginType || childPrice[0].classType,
        false
      );
    }
    if (
      !quotationJourney.returnFlight.infantValue &&
      quotationJourney.passengers.infantNumber > 0
    ) {
      let infantPrice = this.getPrice(
        returnFlightObject.flight.prices,
        returnFlightObject.category,
        'INFANT'
      );

      returnInfantPointsPromise = this.getReturnPointsPromise(
        quotationJourney,
        items,
        infantPrice[0],
        returnFlightObject.flight.fareOriginType || infantPrice[0].classType,
        true
      );
    }

    return [returnChildPointsPromise, returnInfantPointsPromise];
  }

  getDeparturePointsPromise(quotationJourney, items, price, classType, isInfant) {
    return this.getPoints(items, classType, price, quotationJourney.departureFlight.rangePointsPlusMoney, quotationJourney).then((response) => {
      if (!response.error) {
        
        let newDepartureFlight = quotationJourney.departureFlight;
        const ranges = response.ranges ? response.ranges[0] : null;
        const valuesPoints = response.ranges ? response.ranges[0].points : response.points.value;

        if (isInfant) {
          newDepartureFlight.infantValue = valuesPoints;
          newDepartureFlight.infantPointsPlusMoney = ranges;
        } else {
          newDepartureFlight.childValue = valuesPoints;
          newDepartureFlight.childPointsPlusMoney = ranges;
        }

        this.setState({
          quotationJourney: {
            ...quotationJourney,
            departureFlight: newDepartureFlight
          }
        });
      } else {
        throw Error();
      }
    });
  }

  getReturnPointsPromise(quotationJourney, items, price, classType, isInfant) {
    return this.getPoints(items, classType, price, quotationJourney.returnFlight.rangePointsPlusMoney, quotationJourney).then((response) => {
      if (!response.error) {

        let newReturnFlight = quotationJourney.returnFlight;
        const ranges = response.ranges ? response.ranges[0] : null;
        const valuesPoints = response.ranges ? response.ranges[0].points : response.points.value;

        if (isInfant) {
          newReturnFlight.infantValue = valuesPoints;
          newReturnFlight.infantPointsPlusMoney = ranges;
        } else {
          newReturnFlight.childValue = valuesPoints;
          newReturnFlight.childPointsPlusMoney = ranges;
        }

        this.setState({
          quotationJourney: {
            ...quotationJourney,
            returnFlight: newReturnFlight
          }
        });
      } else {
        throw Error();
      }
    });
  }

  getPrice(prices, category, passenger) {
    return prices.filter(
      price =>
        price.category.toUpperCase() === category.toUpperCase() && price.passenger === passenger
    );
  }

  getPoints(items, classType, priceObject, rangePointsPlusMoney, quotationJourney) {
    const payload = Object.assign({}, items, {
      value: priceObject.value,
      currency: priceObject.currency,
      classType: classType,
      passengerType: priceObject.passenger
    });

    if (classType === 'AWARD') {
      let partner = []
      partner.push(this.assemblerPartnerWhenAward(quotationJourney));
      partner != null ? payload.operatingCarriers = partner : null;
    }

    if (rangePointsPlusMoney)
      return ExchangeService.getPointsPlusMoney(payload, rangePointsPlusMoney)
    else
      return ExchangeService.getPoints(payload)
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      messageInfo: null
    });
    window.location.reload();
  }

  obtainValues() {
    let totalAdult =
      this.state.quotationJourney.departureFlight.value +
      (this.state.quotationJourney.returnFlight
        ? this.state.quotationJourney.returnFlight.value
        : 0);
    totalAdult = totalAdult * this.state.quotationJourney.passengers.adultNumber;

    let totalChildren;
    if (this.state.quotationJourney.departureFlight.childValue) {
      totalChildren =
        this.state.quotationJourney.departureFlight.childValue +
        (this.state.quotationJourney.returnFlight
          ? this.state.quotationJourney.returnFlight.childValue
          : 0);
      totalChildren = totalChildren * this.state.quotationJourney.passengers.childNumber;
    }

    let totalInfant;
    if (this.state.quotationJourney.departureFlight.infantValue) {
      totalInfant =
        this.state.quotationJourney.departureFlight.infantValue +
        (this.state.quotationJourney.returnFlight
          ? this.state.quotationJourney.returnFlight.infantValue
          : 0);
      totalInfant = totalInfant * this.state.quotationJourney.passengers.infantNumber;
    }

    let totalTaxes = Number(this.getFee(this.state.quotationJourney).total.value);

    const totalRanges = this.getTotalMoneyOfRanges();    

    let values = {
      totalPoints:
        totalAdult + (totalChildren ? totalChildren : 0) + (totalInfant ? totalInfant : 0),
      totalAdult: totalAdult,
      totalChildren: totalChildren,
      totalInfant: totalInfant,
      totalTaxes: totalTaxes,
      totalTaxesServices: totalTaxes,
      totalTaxesAndMoney: totalTaxes + totalRanges.grandTotal,
      adultNumber: this.state.quotationJourney.passengers.adultNumber,
      childNumber: this.state.quotationJourney.passengers.childNumber,
      infantNumber: this.state.quotationJourney.passengers.infantNumber,
      totalMoneyAdult: totalRanges.totalMoneyAdult,
      totalMoneyChild: totalRanges.totalMoneyChild,
      totalMoneyInfant: totalRanges.totalMoneyInfant
    };

    return values;
  }

  getFee(quotationJourney) {
    let fee;
    if (quotationJourney.returnFlight) {
      fee = quotationJourney.returnFlight.flight.fee[quotationJourney.returnFlight.category];
    } else {
      let selectedCategory = quotationJourney.departureFlight.category;
      let recommendation = quotationJourney.departureFlight.flight.recommendations.filter(
        recommendation =>
          recommendation.departureCategory.toLowerCase() === selectedCategory.toLowerCase()
      );
      fee = recommendation[0].fee;
    }
    return fee;
  }

  getTotalMoneyOfRanges() {
    var { rangePointsPlusMoney, childPointsPlusMoney, infantPointsPlusMoney } = this.state.quotationJourney.departureFlight;
    let totalMoneyAdult = rangePointsPlusMoney ? rangePointsPlusMoney.amount * this.state.quotationJourney.passengers.adultNumber : 0;
    let totalMoneyChild = childPointsPlusMoney ? childPointsPlusMoney.amount * this.state.quotationJourney.passengers.childNumber : 0;
    let totalMoneyInfant = infantPointsPlusMoney ? infantPointsPlusMoney.amount * this.state.quotationJourney.passengers.infantNumber : 0;
    if (this.state.quotationJourney.returnFlight) {
      var { rangePointsPlusMoney, childPointsPlusMoney, infantPointsPlusMoney } = this.state.quotationJourney.returnFlight;
      totalMoneyAdult += rangePointsPlusMoney ? rangePointsPlusMoney.amount * this.state.quotationJourney.passengers.adultNumber : 0;
      totalMoneyChild += childPointsPlusMoney ? childPointsPlusMoney.amount * this.state.quotationJourney.passengers.childNumber : 0;
      totalMoneyInfant += infantPointsPlusMoney ? infantPointsPlusMoney.amount * this.state.quotationJourney.passengers.infantNumber : 0;
    }

    return {
      totalMoneyAdult: totalMoneyAdult,
      totalMoneyChild: totalMoneyChild,
      totalMoneyInfant: totalMoneyInfant,
      grandTotal: (totalMoneyAdult + totalMoneyChild + totalMoneyInfant)
    }
  }

  assemblerPartnerWhenAward(quotationJourney) {
    let partner = null;
    
    if (quotationJourney.departureFlight.flight.recommendations == null) {
      let fare = quotationJourney.departureFlight.flight.fare;
      let fareBasis = this.getFareBasisFromFare(fare);
    
      partner = this.extractPartner(fareBasis);
    } else {
      let isReturnFlightNull = quotationJourney.departureFlight.flight.recommendations[0].returnFlights === null;
      let fare = !isReturnFlightNull ? 
        quotationJourney.departureFlight.flight.recommendations[0].returnFlights[0].categories[0].fare.departure : 
        quotationJourney.departureFlight.flight.recommendations[0].fare;
      let firstFareKey = Object.keys(fare)[0];
      let fareBasis = fare[firstFareKey].fareBasis;

      partner = this.extractPartner(fareBasis);
    }

    return partner;
  }
  
  extractPartner(fareBasis) {
    const parts = fareBasis.split("");
    if (fareBasis.includes("AWARD") && parts.length >= 3) {
      return parts[1] + parts[2];
    } else if (fareBasis.includes("P00") && parts.length >= 2) {
      const lastTwoElements = parts[parts.length - 2] + parts[parts.length - 1];
      if (lastTwoElements === "EK") {
        return lastTwoElements;
      }
    }
    return null;
  }

  getFareBasisFromFare(fare) {
    let fareWithCabinKey = Object.keys(fare).find(key => key !== '');
    let fareWithCabin = fare[fareWithCabinKey];
    let getDeparture = Object.keys(fareWithCabin)[0];
    let fareWithDeparture = fareWithCabin[getDeparture];
    let firstFare = Object.keys(fareWithDeparture)[0];
    return fareWithDeparture[firstFare].fareBasis;
  }

  render() {
    if (this.state.showPrices) {
      return (
        <div>
          <OverviewPrice
            id="componentOverviewPrice"
            alterFlight={this.props.alterFlight}
            values={
              this.state.quotationJourney.values
                ? this.state.quotationJourney.values
                : this.obtainValues()
            }
            departureFlight={this.state.quotationJourney.departureFlight}
            returnFlight={this.state.quotationJourney.returnFlight}
            renderOpen={this.props.renderOpen}
          />
        </div>
      );
    } else {
      return (
        <div>
          <InfoModal
            id="modalChildrenPointsInfo"
            message={this.state.messageInfo}
            showModal={this.state.openModal}
            close={this.closeModal}
            ref={c => {
              this.modalChildrenPointsInfo = c;
            }}
          />
        </div>
      );
    }
  }
}

OverviewPriceContainer.propTypes = propTypes;
OverviewPriceContainer.defaultProps = defaultProps;

export default OverviewPriceContainer;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/overviewPriceContainer/OverviewPriceContainer.jsx